import axios from '../js/ajax'

/** 获取下载页信息 */
export const promotionInvitation = params => axios.get('/user/promotionInvitation', {params});
/** 获取店铺下载页信息 */
export const customerPromotionInvitation = params => axios.get('/customer/promotionInvitation', {params});
/** 获取店铺下载页信息 */
export const getAppInfo = params => axios.get('/app/info', {params});
/** 获取外卖跳转链接 */
export const getChannelLink = params => axios.get('/product/getChannelLink', {params})

export const getWxAuthSdk = params => axios.get('/product/getWeChatJsAuthSignature', {params})



